import http from "../../../NetworkServices/http";

let consoleBaseUrl = process.env.REACT_APP_CH_CONSOLE_API_BASE_URL;
consoleBaseUrl = consoleBaseUrl + "api/v1";

export interface ApiLogFilters {
  page_number: number;
  page_size: number;
  status: string | null;
  search: string;
  api_id?: string;
  status_code?: number | null;
}

export interface ApiLog {
  action: string;
  api_id: string;
  context: any;
  createdAt: number;
  created_time: string;
  header: any;
  request: any;
  status_code: number;
  type: string;
  url: string;
}

export interface ApiLogsResponse {
  status: boolean;
  data: ApiLog[];
  pagination: {
    currentPage: number;
    perPage: number;
    totalPages: number;
    totalRecords: number;
  };
  filters_applied: {
    action: string | null;
    date_range: {
      start: string;
      end: string;
    };
    api_id: string | null;
    search: string;
    status: string | null;
  };
}

export class ApiLogsService {
  static fetchApiLogs(filters: ApiLogFilters): Promise<any> {
    const url = `${consoleBaseUrl}/workspace/api-library-logs/${filters?.api_id}`;
    const params: Record<string, any> = {
      page_number: filters.page_number,
      page_size: filters.page_size,
      status: filters.status,
      search: filters.search,
    };

    if (typeof filters.status_code !== "undefined" && filters.status_code !== null) {
      params.status_code = filters.status_code;
    }

    return http.get(url, { params });
  }
}
